import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ExamContext } from '../contexts/ExamContext';
import ExamSelector from './ExamSelector';

const Welcome = () => {
  const { selectedSet, setSelectedSet, resetExamState } = useContext(ExamContext);
  const navigate = useNavigate();
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    // Clear localStorage and reset exam state when component mounts
    localStorage.removeItem('selectedSet');
    resetExamState();
    // Do NOT setSelectedSet(null)
  }, [resetExamState]);

  useEffect(() => {
    const timer = setInterval(() => setCurrentDateTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const handleSelectSet = (set) => {
    // Just update the selected set, don't navigate yet
    setSelectedSet(set);
  };

  const handleProceedToExam = () => {
    if (selectedSet) {
      navigate('/exam');
    } else {
      alert('Please select an exam set before proceeding.');
    }
  };

  return (
    <div className="welcome-page-wrapper">
      <div className="welcome-content-left">
        <div className="welcome-header-text">
          <h2>Welcome to the Railway Exam Portal</h2>
          <p>Current Date & Time: {currentDateTime.toLocaleString()}</p>
        </div>
        <ExamSelector onSelect={handleSelectSet} selectedSet={selectedSet} onProceed={handleProceedToExam} />
      </div>
      <div className="welcome-papers-right">
        <div className="papers-panel">
          <h3>Available Exam Papers</h3>
          <ExamSelector onSelect={handleSelectSet} selectedSet={selectedSet} showPapersList />
        </div>
      </div>
    </div>
  );
};

export default Welcome;
